/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import PDFAvatar from "../Avatars/PDFAvatar";
import WORDAvatar from "../Avatars/WORDAvatar";
import PPTAvatar from "../Avatars/PPTAvatar";
import HTMLAvatar from "../Avatars/HTMLAvatar";
import TXTAvatar from "../Avatars/TXTAvatar";
import EXCELAvatar from "../Avatars/EXCELAvatar";
import CSVAvatar from "../Avatars/CSVAvatar";
import IMAGEAvatar from "../Avatars/IMAGEAvatar";

import pdf_temp from "../Templates/pdf_temp";
import html_temp from "../Templates/html_temp";
import ppt_temp from "../Templates/ppt_temp";
import doc_temp from "../Templates/doc_temp";
import txt_temp from "../Templates/txt_temp";
import csv_temp from "../Templates/csv_temp";
import xls_temp from "../Templates/xls_temp";
import image_temp from "../Templates/image_temp";

const doc_viewer_map = [
  {
    type: ["DATA"],
    sub_type: ["pdf"],
    viewer: "data",
    template: pdf_temp,
    avatar: PDFAvatar,
    drl_required: true,
  },
  {
    type: ["DATA"],
    sub_type: ["ppt", "pptx"],
    viewer: "data",
    template: ppt_temp,
    avatar: PPTAvatar,
    drl_required: true,
  },
  {
    type: ["DATA"],
    sub_type: ["doc", "docx"],
    viewer: "data",
    template: doc_temp,
    avatar: WORDAvatar,
    drl_required: true,
  },
  {
    type: ["DATA"],
    sub_type: ["html"],
    viewer: "data",
    template: html_temp,
    avatar: HTMLAvatar,
    drl_required: true,
  },
  {
    type: ["DATA"],
    sub_type: ["txt"],
    viewer: "data",
    template: txt_temp,
    avatar: TXTAvatar,
    drl_required: false,
  },
  
];

export default doc_viewer_map;
